import { render, staticRenderFns } from "./ShareRecordManagement.vue?vue&type=template&id=d27e1296&scoped=true"
import script from "./ShareRecordManagement.vue?vue&type=script&lang=js"
export * from "./ShareRecordManagement.vue?vue&type=script&lang=js"
import style0 from "./ShareRecordManagement.vue?vue&type=style&index=0&id=d27e1296&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d27e1296",
  null
  
)

export default component.exports